var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-default",attrs:{"id":"app"}},[_c('MainHeader'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('portal-target',{attrs:{"name":"root"}}),_vm._v(" "),_c('profile-badge-earned-modal'),_vm._v(" "),_c('refresh-notification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }